import React, { Component, useEffect } from "react";

import {
  CCard,
  CButton,
  CCardBody,
  CCollapse,
  CRow,
  CImg,
  CCol,
  CLink,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CPagination
} from "@coreui/react";
import { Portal } from "@material-ui/core";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import { debounce } from "../../utils/debounce";
import UsersCommunityModal from "../CommunityModal/users";
import UserStatistics from "../CommunityModal/userStatistics";
import Loading from "../Loading";
import DataTable from "../Tables/tables";

class CommunityContentUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      // room: null,
      // disciplines: null,
      // tab: 1,
      waiting: true,
      members: true,
      deleteModal: false,
      deleteId: null,
      statisticsModal: null,
      usersModal: false,
      studentListSize: undefined,
      studentsListPage: 1,
      sizePerPage: 10,
      toggleShowAllUsersActivated: true,
      users: [],
      currentPage: 1,
      perPage: 10,
      totalPages: 1
    };
    this.toggleShowAllUsers = this.toggleShowAllUsers.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  componentDidMount() {
    this.handleUsers();
    this.fetchUsers(1);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.toggleShowAllUsersActivated !==
      this.state.toggleShowAllUsersActivated
    ) {
      const delayedSearch = debounce(() => this.handleUsers(), 300);
      delayedSearch();
    }
  }

  async handleUsers() {
    this.setState({ loading: true });
    const objRoomUser = { room: this.props.match.params };

    await axios
      .post(
        `${URL.api}community/room_user/listPaginate?page=${this.state.studentsListPage}&offset=${this.state.sizePerPage}`,
        objRoomUser,
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(
        resp => {
          if (this.props.isRoom) {
            this.setState({
              users: resp.data.data?.users.map(user => ({
                ...user,
                start: new Date(user.start).toLocaleDateString("pt-br", {
                  year: "numeric",
                  day: "numeric",
                  month: "short"
                })
              })),
              studentsListPage: resp.data.meta.current_page,
              studentListSize: resp.data.meta.total,
              loading: false
            });
          } else {
            let users = resp.data.data.users.map(user => ({
              ...user,
              disciplines: resp.data.data.disciplines.filter(
                discipline => discipline.room_user_id === user.id
              )
            }));
            this.setState({
              users: users.map(user => ({
                ...user,
                start: new Date(user.start).toLocaleDateString("pt-br", {
                  year: "numeric",
                  day: "numeric",
                  month: "short"
                })
              })),
              studentsListPage: resp.data.meta.current_page,
              studentListSize: resp.data.meta.total,
              loading: false
            });
          }
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  toggleShowAllUsers() {
    if (this.state.toggleShowAllUsersActivated) {
      this.setState({
        studentsListPage: 1,
        sizePerPage: 1000,
        toggleShowAllUsersActivated: false
      });
    } else {
      this.setState({
        studentsListPage: 1,
        sizePerPage: 10,
        toggleShowAllUsersActivated: true
      });
    }
  }

  toggleWaiting() {
    this.setState(state => ({ waiting: !state.waiting }));
  }

  toggleMembers() {
    this.setState(state => ({ members: !state.members }));
  }

  deleteRoomUser(roomUser) {
    axios
      .post(`${URL.api}community/room_user/delete/${roomUser}`, null, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.handleUsers();
          this.setState({ deleteModal: false });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  acceptRoomUser(roomUser) {
    const obj = {
      authorized: true
    };

    axios
      .post(`${URL.api}community/room_user/update/${roomUser}`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.handleUsers();
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  fetchUsers(page = 1) {
    const objRoomUser = { room: this.props.match.params };
    axios
      .post(
        `${URL.api}community/room_user/listPaginate?page=${page}&offset=${this.state.sizePerPage}`,
        objRoomUser,
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(res => {
        const meta = res.data.meta;

        this.setState({
          users: res.data.data.users,
          currentPage: Number(meta.current_page),
          totalPages: Number(meta.last_page) // força número
        });
      })
      .catch(err => console.error(err));
  }

  render() {
    return (
      <>
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <>
            {this.state.statisticsModal && (
              <UserStatistics
                show={this.state.statisticsModal !== null}
                onClose={() => this.setState({ statisticsModal: null })}
                roomUser={this.state.statisticsModal}
                currentRoute={this.props.currentRoute}
                username={
                  this.state.users.find(
                    u => u.id === this.state.statisticsModal
                  ).user_name
                }
                userId={
                  this.state.users.find(
                    u => u.id === this.state.statisticsModal
                  ).user_id
                }
              />
            )}
            {this.state.usersModal && (
              <UsersCommunityModal
                show={this.state.usersModal !== null}
                onClose={shouldUpdate =>
                  this.setState(
                    { usersModal: null, loading: shouldUpdate },
                    () => shouldUpdate && this.handleUsers()
                  )
                }
                room={this.props.match.params.id}
                currentRoute={this.props.currentRoute}
              />
            )}
            <CModal
              show={this.state.deleteModal}
              onClose={() => this.setState({ deleteModal: false })}
              closeOnBackdrop={false}
            >
              <CModalHeader closeButton className="bg-danger">
                <CModalTitle>Excluir membro</CModalTitle>
              </CModalHeader>
              <CModalBody>
                Deseja excluir o membro selecionado da comunidade?
              </CModalBody>
              <CModalFooter>
                <CButton
                  color="danger"
                  onClick={() => this.deleteRoomUser(this.state.deleteId)}
                >
                  Apagar
                </CButton>{" "}
                <CButton
                  color="secondary"
                  onClick={() => this.setState({ deleteModal: false })}
                >
                  Cancelar
                </CButton>
              </CModalFooter>
            </CModal>
            {this.state.users &&
            this.state.users.filter(user =>
              user.user_name
                .toLowerCase()
                .includes(this.props.search.toLowerCase())
            ).length > 0 ? (
              this.props.isRoom ? (
                <>
                  {this.props.hasPrivilege && (
                    <>
                      <div className="d-flex align-items-center justify-content-end mb-3">
                        <CButton
                          color="primary"
                          onClick={() => this.setState({ usersModal: true })}
                        >
                          <i className="fa fa-plus mr-2"></i>Adicionar Membros
                        </CButton>
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <h4 className="m-0">Aguardando aprovação</h4>
                        <i
                          onClick={() => this.toggleWaiting()}
                          className={`text-muted users-collapse fa fa-chevron-${
                            this.state.waiting ? "up" : "down"
                          }`}
                        ></i>
                      </div>
                      <hr
                        style={{ marginTop: "0.75rem", marginBottom: "1.5rem" }}
                      />
                      <CCollapse show={this.state.waiting}>
                        <CRow>
                          {this.state.users
                            .filter(
                              user =>
                                user.user_name
                                  .toLowerCase()
                                  .includes(this.props.search.toLowerCase()) &&
                                !user.authorized
                            )
                            .map((user, index) => (
                              <CCol md={4} sm={6} key={index}>
                                <CCard>
                                  <CCardBody className="d-flex">
                                    <div
                                      className="bg-white mw-100"
                                      style={{
                                        width: "80px",
                                        height: "80px"
                                      }}
                                    >
                                      <CImg
                                        src={
                                          user.user_photo
                                            ? URL.img + user.user_photo
                                            : `${URL.img}uploads/users/profileEmpty.jpg`
                                        }
                                        className="rounded-circle"
                                        style={{
                                          width: "80px",
                                          height: "80px"
                                        }}
                                      />
                                    </div>
                                    <div className="d-flex flex-column justify-content-center ml-3 text-ellipsis">
                                      <h5 className="card-title mb-1 text-ellipsis">
                                        <CLink
                                          to={`/profile/${user.user_id}`}
                                          style={{ color: "inherit" }}
                                        >
                                          {user.user_name}
                                        </CLink>
                                      </h5>
                                      {user.role_id === 6 ? (
                                        <div className="text-ellipsis">
                                          {user.role_name} de{" "}
                                          {user.disciplines[0].discipline_name}
                                        </div>
                                      ) : (
                                        <div className="text-ellipsis">
                                          {user.role_name}
                                        </div>
                                      )}
                                      <div className="d-flex mt-1 text-ellipsis">
                                        <CButton
                                          color="danger"
                                          className="mr-2"
                                          onClick={() =>
                                            this.acceptRoomUser(user.id)
                                          }
                                        >
                                          Aprovar
                                        </CButton>
                                        <CButton
                                          variant="outline"
                                          color="danger"
                                          onClick={() =>
                                            this.deleteRoomUser(user.id)
                                          }
                                        >
                                          Apagar
                                        </CButton>
                                      </div>
                                    </div>
                                  </CCardBody>
                                </CCard>
                              </CCol>
                            ))}
                        </CRow>
                      </CCollapse>
                      <div className="d-flex align-items-center justify-content-between">
                        <h4 className="m-0">Membros</h4>
                        <i
                          onClick={() => this.toggleMembers()}
                          className={`text-muted users-collapse fa fa-chevron-${
                            this.state.members ? "up" : "down"
                          }`}
                        ></i>
                      </div>
                      <hr
                        style={{ marginTop: "0.75rem", marginBottom: "1.5rem" }}
                      />
                    </>
                  )}
                  <CCollapse show={this.state.members}>
                    <CRow>
                      {this.state.users
                        .filter(
                          user =>
                            user.user_name
                              .toLowerCase()
                              .includes(this.props.search.toLowerCase()) &&
                            user.authorized
                        )
                        .map((user, index) => (
                          <CCol md={4} sm={6} key={index}>
                            <CCard>
                              <CCardBody className="d-flex text-ellipsis">
                                <div
                                  className="bg-white mw-100"
                                  style={{ width: "80px", height: "80px" }}
                                >
                                  <CImg
                                    src={
                                      user.user_photo
                                        ? URL.img + user.user_photo
                                        : `${URL.img}uploads/users/profileEmpty.jpg`
                                    }
                                    className="rounded-circle"
                                    style={{ width: "80px", height: "80px" }}
                                  />
                                </div>
                                <div
                                  className="d-flex flex-column justify-content-center pl-3 flex-1 text-ellipsis"
                                  style={{ minHeight: "80px" }}
                                >
                                  <div className="d-flex">
                                    <h5 className="card-title text-ellipsis mb-1 flex-1">
                                      {this.props.isStudent ? (
                                        <span
                                          style={{
                                            color: "inherit",
                                            cursor: "default"
                                          }}
                                        >
                                          {user.user_name}
                                        </span>
                                      ) : (
                                        <CLink
                                          to={`/profile/${user.user_id}`}
                                          style={{ color: "inherit" }}
                                        >
                                          {user.user_name}
                                        </CLink>
                                      )}
                                    </h5>
                                    {this.props.isRoom &&
                                      this.props.hasPrivilege &&
                                      !user.administrator && (
                                        <CDropdown>
                                          <CDropdownToggle
                                            color="white"
                                            className="card-header-action remove-caret"
                                          >
                                            <i className="fa fa-ellipsis-v"></i>
                                          </CDropdownToggle>
                                          <Portal>
                                            <CDropdownMenu placement="top-start">
                                              <CDropdownItem
                                                onClick={() =>
                                                  this.setState({
                                                    deleteModal: true,
                                                    deleteId: user.id
                                                  })
                                                }
                                              >
                                                Excluir
                                              </CDropdownItem>
                                            </CDropdownMenu>
                                          </Portal>
                                        </CDropdown>
                                      )}
                                  </div>
                                  {user.administrator ? (
                                    <div className="text-ellipsis">
                                      Administrador
                                    </div>
                                  ) : (
                                    <div className="text-ellipsis">Membro</div>
                                  )}
                                  <div className="text-muted text-ellipsis">
                                    Adicionado em{" "}
                                    {new Date(user.start).toLocaleDateString()}
                                  </div>
                                </div>
                              </CCardBody>
                            </CCard>
                          </CCol>
                        ))}
                    </CRow>

                    {/* Paginação */}
                    <div
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "15px",
                        fontFamily: "Arial, sans-serif"
                      }}
                    >
                      <button
                        className="btn-primary"
                        disabled={this.state.currentPage <= 1}
                        onClick={() =>
                          this.fetchUsers(this.state.currentPage - 1)
                        }
                        style={{
                          padding: "8px 14px",
                          borderRadius: "5px",
                          border: "1px solid #ccc",
                          margin: "0px 10px 20px",
                          backgroundColor:
                            this.state.currentPage <= 1 ? "#eee" : "bg-primary",
                          color: this.state.currentPage <= 1 ? "#aaa" : "#fff",
                          cursor:
                            this.state.currentPage <= 1
                              ? "not-allowed"
                              : "pointer",
                          transition: "background-color 0.3s"
                        }}
                      >
                        Anterior
                      </button>

                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          margin: "0px 10px 20px"
                        }}
                      >
                        Página {this.state.currentPage} de{" "}
                        {this.state.totalPages}
                      </span>

                      <button
                        className="btn-primary"
                        disabled={
                          this.state.currentPage >= this.state.totalPages
                        }
                        onClick={() =>
                          this.fetchUsers(this.state.currentPage + 1)
                        }
                        style={{
                          padding: "8px 14px",
                          borderRadius: "5px",
                          margin: "0px 10px 20px",
                          border: "1px solid #ccc",
                          backgroundColor:
                            this.state.currentPage >= this.state.totalPages
                              ? "#eee"
                              : "bg-primary",
                          color:
                            this.state.currentPage >= this.state.totalPages
                              ? "#aaa"
                              : "#fff",
                          cursor:
                            this.state.currentPage >= this.state.totalPages
                              ? "not-allowed"
                              : "pointer",
                          transition: "background-color 0.3s"
                        }}
                      >
                        Próxima
                      </button>
                    </div>
                  </CCollapse>
                </>
              ) : (
                <CRow>
                  <CCol md={12}>
                    <CCard>
                      <CCardBody className="d-flex text-ellipsis flex-column">
                        <DataTable
                          isRoomUsersPage
                          noClick
                          toggleShowAllUsersActivated={
                            this.state.toggleShowAllUsersActivated
                          }
                          toggleShowAllUsers={this.toggleShowAllUsers}
                          noSort
                          list={this.state.users}
                          title="Usuários da turma"
                          subtitle="Tenha acesso as informações dos membros da turma"
                          currentPage={this.state.studentsListPage}
                          totalItems={this.state.studentListSize}
                          perPage={this.state.sizePerPage}
                          onPageChange={page =>
                            this.setState({ studentsListPage: page }, () =>
                              this.handleUsers()
                            )
                          }
                          onSizePerPageList={size =>
                            this.setState({ sizePerPage: size }, () =>
                              this.handleUsers()
                            )
                          }
                          header={[
                            { name: "user_name", denomination: "Nome" },
                            {
                              name: "role_name",
                              denomination: "Papel"
                            },
                            {
                              name: "username",
                              denomination: "Usuário"
                            },
                            {
                              name: "start",
                              denomination: "Data de entrada na turma"
                            }
                          ]}
                        />
                      </CCardBody>
                    </CCard>
                  </CCol>
                </CRow>
              )
            ) : (
              <div className="d-flex align-items-center justify-content-center m-3">
                Nenhum membro encontrado
              </div>
            )}
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommunityContentUsers);
